import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Phuluc5 from "components/Tonghopvantai/Phuluc5.js";
export default function Phuluc5TH() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Phụ lục 5",
            tabContent: <Phuluc5 />,
          },
        ]}
      />
    </div>
  );
}
